<div class="shared-ui-listview shared-ui-control" *ngIf="control">
  <label for="lv" class="fwform-label">{{ label }}</label>
  <div class="shared-ui-listViewFlex">
    <div *ngFor="let option of options; let i=index" class="col-md-2">
      <label>
        <input #id type="checkbox" [value]="option[valueName]" [checked]="option[checkCondition]!=null">
        {{option[displayName]}}
      </label>
    </div>
  </div>
  <ngb-alert *ngIf="control.errors" [dismissible]="false">
    <div class="shared-ui-listview-val-error" *ngFor="let error of control.errors | validationErrorKeys">{{messages[error]}}</div>
  </ngb-alert>
</div>
